import { render, staticRenderFns } from "./PartnersForm.vue?vue&type=template&id=39946114&scoped=true&"
import script from "./PartnersForm.vue?vue&type=script&lang=js&"
export * from "./PartnersForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnersForm.vue?vue&type=style&index=0&id=39946114&prod&lang=scss&"
import style1 from "./PartnersForm.vue?vue&type=style&index=1&id=39946114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39946114",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTextArea: require('/var/www/app/components/base/BaseTextArea.vue').default,BaseInput: require('/var/www/app/components/base/BaseInput.vue').default})
